import {
  rehydrateMarksMiddleware,
  initReduxStateMiddleware,
  initializedStoreMiddleware,
  tagManagerMiddleware,
  renderClientApp
} from '@finect/front-core/ReactApp';
import { configureStore } from './store';
import './imported';
import BrowserApp from './index-browser';

const settings = {
  initMiddlewares: [
    rehydrateMarksMiddleware,
    tagManagerMiddleware,
    initReduxStateMiddleware,
    initializedStoreMiddleware
  ],
  configureStore,
  BrowserApp
};

renderClientApp(settings);
